import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import RailwayAlertIcon from "@mui/icons-material/RailwayAlert";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import LanIcon from "@mui/icons-material/Lan";
import SourceIcon from "@mui/icons-material/Source";
import PeopleIcon from "@mui/icons-material/People";
import AlarmIcon from "@mui/icons-material/Alarm";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import EngineeringIcon from "@mui/icons-material/Engineering";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import SummarizeIcon from "@mui/icons-material/Summarize";
import PlaceIcon from "@mui/icons-material/Place";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import InsightsIcon from "@mui/icons-material/Insights";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LooksIcon from "@mui/icons-material/Looks";
import { ChromeReaderMode } from "@mui/icons-material";
import { MdSpaceDashboard } from "react-icons/md";
import { MdSettingsRemote } from "react-icons/md";
import { HiWrenchScrewdriver } from "react-icons/hi2";
import { MdCable, MdRouter, MdPhone, MdPower, MdVideocam } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";

import {
  ASSET_ASSIGNMENT_ICON,
  FORM_ASSIGNMENT_ICON,
  REPORTS_ICON,
  ASSET_TRANSFER_ICON,
  ALARM_RULES_ICON,
  UTILISATION_ICON,
  SFR_ICON,
} from "../../ICONS/Icons";
import { app_config } from "../../Common/EndPoints";

// export const ApplicationRoutes = [
//   {
//     label: "Home",
//     url: "home",
//     icon: <HomeIcon />,
//     name: "Dashboard",
//   },
//   {
//     label: "Alarms",
//     url: "alarms",
//     icon: <RailwayAlertIcon />,
//     name: "Alarms",
//   },
//   {
//     label: "Reports",
//     url: "#",
//     icon: REPORTS_ICON,
//     name: "Reports",
//   },
//   {
//     label: "Telemetry",
//     url: "telemetry",
//     icon: <LanIcon />,
//     name: "Telemetry",
//   },
//   {
//     label: "Yard View",
//     url: "yard-view",
//     icon: <AnalyticsIcon />,
//     name: "YardView",
//   },
//   {
//     label: "Assets",
//     url: "assets",
//     icon: <DevicesOtherIcon />,
//     name: "Assets",
//   },
//   // {
//   //   label: "Maintenance Roster",
//   //   url: "maintenance-roster",
//   //   icon: <EngineeringIcon />,
//   // },
// ];

// export const forAdmin = [
//   // {
//   //   label: "Rules",
//   //   url: "rules",
//   //   icon: <IntegrationInstructionsIcon />,
//   // },
//   {
//     label: "User",
//     url: "user",
//     icon: <PersonPinIcon />,
//     name: "Users",
//   },
//   {
//     label: "Form Creator",
//     url: "#",
//     // url: "form-creator",
//     icon: <DynamicFormIcon />,
//     name: "FormCreator",
//   },
//   {
//     label: "Form Assignment",
//     url: "form-assignment",
//     icon: FORM_ASSIGNMENT_ICON,
//     name: "Forms",
//   },
//   {
//     label: "Asset Assignment",
//     url: "asset-assignment",
//     icon: ASSET_ASSIGNMENT_ICON,
//     name: "AssetAssignment",
//   },
//   {
//     label: "Asset Transfer",
//     url: "asset-transfer",
//     icon: ASSET_TRANSFER_ICON,
//     name: "AssetTransfer",
//   },
// ];

// const fontStyle = { fontSize: 25 };
// export const Dashboard_Tiles_User = [
//   {
//     label: "Alarms",
//     url: "alarms",
//     icon: <AlarmIcon sx={fontStyle} />,
//   },
//   {
//     label: "Telemetry",
//     url: "telemetry",
//     icon: <LanIcon sx={fontStyle} />,
//   },
//   {
//     label: "Yard View",
//     url: "yard-view",
//     icon: <AnalyticsIcon sx={fontStyle} />,
//   },
//   // {
//   //   label: "Maintenance Roster",
//   //   url: "maintenance-roster",
//   //   icon: <EngineeringIcon sx={fontStyle} />,
//   // },
//   {
//     label: "Assets",
//     url: "assets",
//     icon: <DevicesOtherIcon sx={fontStyle} />,
//   },
// ];

// export const Dashboard_Tiles_Admin = [
//   {
//     label: "Alarms",
//     url: "alarms",
//     icon: <AlarmIcon sx={fontStyle} />,
//   },
//   {
//     label: "Telemetry",
//     url: "telemetry",
//     icon: <LanIcon sx={fontStyle} />,
//   },
//   {
//     label: "Yard View",
//     url: "yard-view",
//     icon: <AnalyticsIcon sx={fontStyle} />,
//   },
//   {
//     label: "Assets",
//     url: "assets",
//     icon: <DevicesOtherIcon sx={fontStyle} />,
//   },
//   {
//     label: "User",
//     url: "user",
//     icon: <PersonPinIcon />,
//   },
//   // {
//   //   label: "Maintenance Roster",
//   //   url: "maintenance-roster",
//   //   icon: <EngineeringIcon sx={fontStyle} />,
//   // },
//   // {
//   //   label: "Rules",
//   //   url: "rules",
//   //   icon: <IntegrationInstructionsIcon />,
//   // },
// ];

export const sidebarTiles: any = {
  entities: {
    DASHBOARD: { url: "home", icon: <HomeIcon />, label: "Home" },
    MIS_DASHBOARD: { url: "mis-home", icon: <DashboardIcon />, label: "MIS-Home" },
    ALARM: { url: "alarms", icon: <RailwayAlertIcon />, label: "Alarms" },
    REPORT: { url: "#", icon: REPORTS_ICON, label: "Reports", showPopover: true },
    ASSET_UTILIZATION: { url: "#", icon: UTILISATION_ICON, label: "Asset Utilization", showPopover: true },
    TREND: { url: "trend", icon: <InsightsIcon />, label: "Trend View" },
    TELEMETRY: { url: "telemetry", icon: <LanIcon />, label: "Telemetry" },
    YARDVIEW: { url: "yard-view", icon: <AnalyticsIcon />, label: "Yard View" },
    ASSET: { url: "assets", icon: <DevicesOtherIcon />, label: "Assets" },
    HEALTH_MONITORING: { url: "health-monitoring", icon: <MonitorHeartIcon />, label: "Health Monitoring" },
    GIS: { url: "gis", icon: <PlaceIcon />, label: "Gis View" },
    SFR: { url: "failure-report", icon: SFR_ICON, label: "Telecom Failure Report" },
    USER: { url: "user", icon: <PersonPinIcon />, label: "User" },
    BIODATA: { url: "employeebiodata", icon: <GroupIcon />, label: "Employee Biodata" },

    FORM: { url: "#", icon: <DynamicFormIcon />, label: "Form Creator", showPopover: true },
    FORM_ASSIGNMENT: { url: "form-assignment", icon: FORM_ASSIGNMENT_ICON, label: "Form Assignment" },
    ASSET_ASSIGNMENT: { url: "asset-assignment", icon: ASSET_ASSIGNMENT_ICON, label: "Asset Assignment" },
    // ASSET_TRANSFER: { url: "asset-transfer", icon: ASSET_TRANSFER_ICON, label: "Asset Transfer" },
    ALARM_RULE: { url: "alarm-rules", icon: ALARM_RULES_ICON, label: "Alarm Rules" },
    AUDIT_LOG: { url: "audit-log", icon: <LockOpenIcon />, label: "Audit Log" },
    ADMIN_PANEL: { url: "admin-panel", icon: <AdminPanelSettingsIcon />, label: "Admin Panel" },
    MIS: { url: "#", icon: <ChromeReaderMode />, label: "MIS Reports", showPopover: true },
    JOINT_INSPECTION: {
      url: "joint-inspection",
      icon: <LooksIcon />,
      label: "Joint Inspection",
    },
    PCDO: { url: "pcdo", icon: <SummarizeIcon />, label: "PCDO" },
  },
};
sidebarTiles.ids = Object.keys(sidebarTiles.entities).map((key) => key);

export const newSidebarRoutes = [
  {
    key: "DASHBOARD", icon: <MdSpaceDashboard />, type: "collapse_list", label: "Dashboards", childs: [
      { key: "ALARM_DASHBOARD", url: "", icon: <MdSpaceDashboard />, type: "route_comp", label: "Unified Dashboard", childs: null },
      { key: "KAVACH_DASHBOARD", url: "kavach-dashboard", icon: <MdRouter />, type: "route_comp", label: "KAVACH Dashboard", childs: null, system: "KAVACH" },
      { key: "VOIP_DASHBOARD", url: "voip-dashboard", icon: <MdPhone />, type: "route_comp", label: "VoIP Dashboard", childs: null, system: "VoIP" },
      { key: "FAMS_RE", url: app_config.fams_app_url, icon: <MdCable />, type: "rediect_url", label: "OFC (FMS)", childs: null },
      { key: "TMMS_DASHBOARD", url: "tmms-dashboard", icon: <HiWrenchScrewdriver />, type: "route_comp", label: "TMMS Dashboard", childs: null },
      { key: "SYSTEM_DASHBOARD", url: "system-alarm-dashboard", icon: <MdSettingsRemote />, type: "route_comp", label: "Alarm Dashboard", childs: null },
      { key: "SMPS_DASHBOARD", url: "smps-dashboard", icon: <MdPower />, type: "route_comp", label: "Power Supply (SMPS)", childs: null, system: "SMPS" },
      { key: "CCTV_DASHBOARD", url: "cctv-dashboard", icon: <MdVideocam />, type: "route_comp", label: "CCTV Dashboard", childs: null, system: "NEW CCTV System" },
    ]
  },
  { key: "ALARM", url: "alarms", icon: <RailwayAlertIcon />, type: "route_comp", label: "Alarms", childs: null },
  {
    key: "REPORT", icon: <BiSolidReport />, type: "collapse_list", label: "Reports", childs: [
      { key: "FAILURE_BY_CATEGORY", url: "reports/failures-by-category", icon: null, type: "route_comp", label: "Failures by Category", childs: null },
      { key: "FAILURE_BY_ALARMTYPE", url: "reports/failures-by-alarmType", icon: null, type: "route_comp", label: "Failures by Alarm Type", childs: null },
      { key: "FAILURE_BY_GEARTYPE", url: "reports/failures-by-gearType", icon: null, type: "route_comp", label: "Failures by Asset Type", childs: null },
      { key: "FAILURE_BY_DEVICES", url: "reports/failures-by-devices", icon: null, type: "route_comp", label: "Failures by Assets", childs: null },
      { key: "MIS_REPORTS", url: "mis-reports", icon: null, type: "route_comp", label: "Mis Reports", childs: null },
    ]
  },
  {
    key: "TELEMETRY", icon: <LanIcon />, type: "collapse_list", label: "System Telemetry", childs: []
  },
  { key: "ASSETS", url: "assets", icon: <DevicesOtherIcon />, type: "route_comp", label: "Assets Register", childs: null },
  { key: "USER", url: "user", icon: <PersonPinIcon />, type: "route_comp", label: "Users", childs: null },
  { key: "BIODATA", url: "employeebiodata", icon: <GroupIcon />, type: "route_comp", label: "Employee Biodata", childs: null },
  { key: "SFR", url: "failure-report", icon: SFR_ICON, type: "route_comp", label: "Telecom Failure Incidences", childs: null },
  {
    key: "FORM", icon: <DynamicFormIcon />, type: "collapse_list", label: "Form Creator", childs: [
      { key: "FORM_MAINTENANCE", url: "forms/maintenance", icon: null, type: "route_comp", label: "Maintenance Form", childs: null },
      { key: "FORM_ASSETS", url: "forms/asset", icon: null, type: "route_comp", label: "Asset Form", childs: null },

    ]
  },
  {
    key: "DOCUMENT_MANAGEMENT", icon: <SourceIcon />, type: "collapse_list", label: "Document Management", childs: [
      { key: "TYPICAL_DRAWING_STORAGE", url: "document-management/typical-drawing-storage", icon: null, type: "route_comp", label: "Typical Drawing Storage", childs: null },
      { key: "LASTEST_INSTRUCTION_GUIDELINE", url: "document-management/latest-instruction-guideline", icon: null, type: "route_comp", label: "Latest Instruction Guideline", childs: null },
      { key: "PCCL_STORAGE", url: "document-management/pccl-storage", icon: null, type: "route_comp", label: "PCCL Storage", childs: null },
    ]
  },
  { key: "HEALTH_MONITORING", url: "health-monitoring", icon: <MonitorHeartIcon />, type: "route_comp", label: "Health Monitoring", childs: null },
  { key: "FORM_ASSIGNMENT", url: "form-assignment", icon: FORM_ASSIGNMENT_ICON, type: "route_comp", label: "Form Assignment", childs: null },
  { key: "ASSET_ASSIGNMENT", url: "asset-assignment", icon: ASSET_ASSIGNMENT_ICON, type: "route_comp", label: "Asset Assignment", childs: null },
  { key: "ALARM_RULE", url: "alarm-rules", icon: ALARM_RULES_ICON, type: "route_comp", label: "Alarm Rules", childs: null },
  { key: "AUDIT_LOG", url: "audit-log", icon: <LockOpenIcon />, type: "route_comp", label: "Audit Log", childs: null },
  { key: "ADMIN_PANEL", url: "admin-panel", icon: <AdminPanelSettingsIcon />, type: "route_comp", label: "Admin Panel", childs: null },
  { key: "JOINT_INSPECTION", url: "joint-inspection", icon: <LooksIcon />, type: "route_comp", label: "Joint Inspection", childs: null },
  { key: "PCDO", url: "pcdo", icon: <SummarizeIcon />, type: "route_comp", label: "PCDO", childs: null },

];

export const PopOverContent = {
  "Form Creator": [
    { label: "Maintenance Form", url: "forms/maintenance", state: null },
    { label: "Asset Form", url: "forms/asset", state: null },
  ],

  Reports: [
    { label: "Failures by Category", url: "reports/failures-by-category", state: { navOrigin: "navigation" } },
    { label: "Failures by Alarm Type", url: "reports/failures-by-alarmType", state: { navOrigin: "navigation" } },
    { label: "Failures by Asset Type", url: "reports/failures-by-gearType", state: { navOrigin: "navigation" } },
    { label: "Failures by Devices", url: "reports/failures-by-devices", state: { navOrigin: "navigation" } },
  ],
  "Asset Utilization": [
    { label: "Point Machine Utilization", url: "utilization/point-machine", state: null },
    { label: "Track Circuit Utilization", url: "utilization/track-circuit", state: null },
  ],

  "MIS Reports": [
    { label: "Codal Life Expired Asset", url: "codal-life-expired-asset", state: null },
    { label: "Midlife Rehabilitation", url: "midlife-rehabilitation", state: null },
    { label: "Maintenance Overdue", url: "maintenance-overdue", state: null },
    { label: "Maintenance Deficiency", url: "maintenance-deficiency", state: null },
    { label: "SFR Reports", url: "sfr-reports", state: null },
  ],
};
